<script lang="ts">
	import { format } from 'svelte-i18n';
	import { findClosestAngle } from '../weather_station_helpers';

	export let statuses;

	$: wind = statuses.find((i) => i.name === 'speed:0')?.value;
	$: gust = statuses.find((i) => i.name === 'speed:1')?.value;
	$: windDirection = statuses.find((i) => i.name === 'direction:0');

	let windDirectionValue = 0;
	$: {
		if (windDirection?.rawValue != windDirectionValue) {
			windDirectionValue = findClosestAngle(windDirectionValue, windDirection?.rawValue);
		}
	}
</script>

<div class="card wind">
	<div class="content-wind">
		<div class="wrapper-right-container">
			<div class="header-row">
				<i class="fas fa-wind header-icon"></i>
				<div class="label">{$format('title_wind_card', { default: 'Wind' })}</div>
			</div>
			<div class="wind-left-container">
				<div class="wind-main-content">
					<div class="wind-details">
						<div class="wind-item d-flex align-items-center">
							<span class="second-label"
								>{$format('label_speed', { default: 'Speed' })}</span
							>
							<!-- <Text element="span" styleType="body-small" class="mr-xl" >{$format('label_speed', { default: 'Speed' })}</Text> -->
							<span class="second-value">{wind || 'N/A'}</span>
							<!-- <Text element="span" styleType="body-extra-small" style="color: #8e8e93;">{wind}</Text> -->
						</div>
						<div class="wind-separator"></div>
						<div class="wind-item align-items-center">
							<span class="second-label">{$format('label_gust', { default: 'Gust' })}</span
							>
							<!-- <Text element="span" styleType="body-small" class="mr-xl">{$format('label_gust', { default: 'Gust' })}</Text> -->
							<span class="second-value">{gust || 'N/A'}</span>
							<!-- <Text element="span" styleType="body-extra-small" style="color: #8e8e93;">{gust}</Text> -->
						</div>
						<div class="wind-separator"></div>
						<div class="wind-item align-items-center">
							<span class="second-label"
								>{$format('label_direction', { default: 'Direction' })}</span
							>
							<!-- <Text element="span" styleType="body-small">{$format('label_direction', { default: 'Direction' })}</Text> -->
							<span class="wind-value">{windDirection?.direction || 'N/A'}</span>
							<!-- <Text element="span" styleType="body-extra-small" style="color: #8e8e93;">{windDirection?.direction}</Text> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="wind-right-container">
			<svg
				width="120"
				height="120"
				viewBox="0 0 120 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g x="0" y="0" id="wind-circle">
					<path d="M67.0898 19.7904L67.7988 15.7695" stroke="#9A9FA4" />
					<path d="M70.5674 20.561L71.6241 16.6172" stroke="#9A9FA4" />
					<path d="M73.9644 21.6326L75.3608 17.7959" stroke="#9A9FA4" />
					<path d="M77.2554 22.9953L78.9809 19.2949" stroke="#9A9FA4" />
					<path d="M80.4146 24.6404L82.456 21.1045" stroke="#9A9FA4" />
					<path d="M83.4187 26.5535L85.7606 23.209" stroke="#9A9FA4" />
					<path d="M86.2446 28.7224L88.8691 25.5947" stroke="#9A9FA4" />
					<path d="M88.8706 31.1293L91.7577 28.2422" stroke="#9A9FA4" />
					<path d="M91.2771 33.7553L94.4048 31.1309" stroke="#9A9FA4" />
					<path d="M93.4456 36.5801L96.7901 34.2383" stroke="#9A9FA4" />
					<path d="M95.3591 39.5844L98.8951 37.543" stroke="#9A9FA4" />
					<path d="M97.0039 42.7441L100.704 41.0186" stroke="#9A9FA4" />
					<path d="M98.3669 46.0351L102.204 44.6387" stroke="#9A9FA4" />
					<path d="M99.438 49.4317L103.382 48.375" stroke="#9A9FA4" />
					<path d="M100.209 52.9092L104.23 52.2002" stroke="#9A9FA4" />
					<path d="M100.209 67.0898L104.23 67.7988" stroke="#9A9FA4" />
					<path d="M99.438 70.5664L103.382 71.6231" stroke="#9A9FA4" />
					<path d="M98.3669 73.9639L102.204 75.3603" stroke="#9A9FA4" />
					<path d="M97.0039 77.2549L100.704 78.9804" stroke="#9A9FA4" />
					<path d="M95.3591 80.4141L98.8951 82.4555" stroke="#9A9FA4" />
					<path d="M93.4456 83.418L96.7901 85.7598" stroke="#9A9FA4" />
					<path d="M91.2771 86.2441L94.4048 88.8686" stroke="#9A9FA4" />
					<path d="M88.8706 88.8701L91.7577 91.7572" stroke="#9A9FA4" />
					<path d="M86.2446 91.2764L88.8691 94.4041" stroke="#9A9FA4" />
					<path d="M83.4187 93.4453L85.7606 96.7898" stroke="#9A9FA4" />
					<path d="M80.4146 95.3584L82.456 98.8943" stroke="#9A9FA4" />
					<path d="M77.2554 97.0039L78.9809 100.704" stroke="#9A9FA4" />
					<path d="M73.9644 98.3662L75.3608 102.203" stroke="#9A9FA4" />
					<path d="M70.5674 99.4375L71.6241 103.381" stroke="#9A9FA4" />
					<path d="M67.0898 100.209L67.7988 104.23" stroke="#9A9FA4" />
					<path d="M52.9102 100.209L52.2012 104.23" stroke="#9A9FA4" />
					<path d="M49.4325 99.4375L48.3757 103.381" stroke="#9A9FA4" />
					<path d="M46.0356 98.3662L44.6392 102.203" stroke="#9A9FA4" />
					<path d="M42.7448 97.0039L41.0193 100.704" stroke="#9A9FA4" />
					<path d="M39.5854 95.3584L37.5439 98.8943" stroke="#9A9FA4" />
					<path d="M36.5811 93.4453L34.2393 96.7898" stroke="#9A9FA4" />
					<path d="M33.7553 91.2764L31.1309 94.4041" stroke="#9A9FA4" />
					<path d="M31.1293 88.8701L28.2422 91.7572" stroke="#9A9FA4" />
					<path d="M28.7229 86.2441L25.5952 88.8686" stroke="#9A9FA4" />
					<path d="M26.5545 83.418L23.21 85.7598" stroke="#9A9FA4" />
					<path d="M24.6409 80.4141L21.105 82.4555" stroke="#9A9FA4" />
					<path d="M22.996 77.2549L19.2957 78.9804" stroke="#9A9FA4" />
					<path d="M21.6329 73.9639L17.7961 75.3603" stroke="#9A9FA4" />
					<path d="M20.5617 70.5664L16.6179 71.6231" stroke="#9A9FA4" />
					<path d="M19.7909 67.0898L15.77 67.7988" stroke="#9A9FA4" />
					<path d="M19.7909 52.9092L15.77 52.2002" stroke="#9A9FA4" />
					<path d="M20.5617 49.4317L16.6179 48.375" stroke="#9A9FA4" />
					<path d="M21.6329 46.0351L17.7961 44.6387" stroke="#9A9FA4" />
					<path d="M22.996 42.7441L19.2957 41.0186" stroke="#9A9FA4" />
					<path d="M24.6409 39.5844L21.105 37.543" stroke="#9A9FA4" />
					<path d="M26.5545 36.5801L23.21 34.2383" stroke="#9A9FA4" />
					<path d="M28.7229 33.7553L25.5952 31.1309" stroke="#9A9FA4" />
					<path d="M31.1293 31.1293L28.2422 28.2422" stroke="#9A9FA4" />
					<path d="M33.7553 28.7224L31.1309 25.5947" stroke="#9A9FA4" />
					<path d="M36.5811 26.5535L34.2393 23.209" stroke="#9A9FA4" />
					<path d="M39.5854 24.6404L37.5439 21.1045" stroke="#9A9FA4" />
					<path d="M42.7448 22.9953L41.0193 19.2949" stroke="#9A9FA4" />
					<path d="M46.0356 21.6326L44.6392 17.7959" stroke="#9A9FA4" />
					<path d="M49.4325 20.561L48.3757 16.6172" stroke="#9A9FA4" />
					<path d="M52.9102 19.7904L52.2012 15.7695" stroke="#9A9FA4" />
					<path
						d="M57.1485 19.8408V12.6826H58.1202L61.8799 18.3027V12.6826H62.7881V19.8408H61.8165L58.0567 14.2158V19.8408H57.1485Z"
						fill="#9A9FA4"
					/>
					<path
						d="M100.838 63.7559V56.5977H106.014V57.4424H101.785V59.6348H105.745V60.4746H101.785V62.9111H106.18V63.7559H100.838Z"
						fill="#9A9FA4"
					/>
					<path
						d="M57.0491 104.305L57.9426 104.227C57.985 104.585 58.0826 104.879 58.2356 105.11C58.3919 105.338 58.6327 105.524 58.9583 105.667C59.2838 105.807 59.65 105.877 60.0569 105.877C60.4182 105.877 60.7372 105.823 61.0139 105.716C61.2906 105.608 61.4957 105.462 61.6292 105.276C61.7659 105.088 61.8342 104.882 61.8342 104.661C61.8342 104.437 61.7691 104.241 61.6389 104.075C61.5087 103.906 61.2939 103.764 60.9944 103.65C60.8023 103.576 60.3775 103.46 59.72 103.304C59.0624 103.144 58.6018 102.994 58.3381 102.854C57.9963 102.675 57.7408 102.454 57.5715 102.19C57.4055 101.924 57.3225 101.626 57.3225 101.297C57.3225 100.936 57.4251 100.599 57.6301 100.286C57.8352 99.9704 58.1347 99.7311 58.5286 99.5684C58.9225 99.4056 59.3603 99.3242 59.842 99.3242C60.3726 99.3242 60.8398 99.4105 61.2434 99.583C61.6503 99.7523 61.9628 100.003 62.1809 100.335C62.399 100.667 62.5162 101.043 62.5325 101.463L61.6243 101.531C61.5754 101.079 61.4094 100.737 61.1262 100.506C60.8463 100.275 60.4312 100.159 59.8811 100.159C59.3082 100.159 58.8899 100.265 58.6262 100.477C58.3658 100.685 58.2356 100.937 58.2356 101.233C58.2356 101.491 58.3284 101.702 58.5139 101.868C58.6962 102.034 59.1715 102.205 59.9397 102.381C60.7112 102.553 61.2402 102.705 61.5266 102.835C61.9433 103.027 62.2509 103.271 62.4495 103.567C62.648 103.86 62.7473 104.199 62.7473 104.583C62.7473 104.964 62.6383 105.324 62.4202 105.662C62.2021 105.997 61.8879 106.259 61.4778 106.448C61.0709 106.634 60.6119 106.727 60.1008 106.727C59.4531 106.727 58.9094 106.632 58.47 106.443C58.0338 106.255 57.6904 105.971 57.4397 105.594C57.1923 105.213 57.0621 104.783 57.0491 104.305Z"
						fill="#9A9FA4"
					/>
					<path
						d="M13.9177 63.7559L12.0183 56.5977H12.99L14.0788 61.29C14.196 61.7816 14.2969 62.2699 14.3816 62.7549C14.5639 61.9899 14.6713 61.5488 14.7038 61.4316L16.0661 56.5977H17.2087L18.2341 60.2207C18.4913 61.1191 18.6768 61.9639 18.7907 62.7549C18.8819 62.3024 19.0007 61.7832 19.1472 61.1973L20.2702 56.5977H21.2224L19.2595 63.7559H18.3464L16.8376 58.3018C16.7107 57.846 16.6358 57.5661 16.613 57.4619C16.5381 57.7907 16.4681 58.0706 16.403 58.3018L14.8845 63.7559H13.9177Z"
						fill="#9A9FA4"
					/>
				</g>
				<g id="wind-arrow" transform={`rotate(${windDirectionValue || 0})`}>
					<path
						d="M60 90.6729V72.6729"
						stroke="#EDEDED"
						stroke-width="3"
						stroke-linecap="square"
					/>
					<path
						d="M60.0003 94.7325L57.554 90.0234L62.4475 90.0335L60.0003 94.7325Z"
						fill="#EDEDED"
						stroke="#EDEDED"
					/>
					<path
						d="M59.0001 27.2496C58.9996 26.6973 59.4468 26.25 59.9991 26.2506C60.5514 26.2512 60.9996 26.6994 61.0001 27.2516C61.0007 27.8039 60.5534 28.2512 60.0011 28.2506C59.4489 28.25 59.0007 27.8019 59.0001 27.2496Z"
						fill="#EDEDED"
						stroke="#EDEDED"
						stroke-width="3"
					/>
					<path
						d="M60.0002 47.251L59.9797 27.251"
						stroke="#EDEDED"
						stroke-width="3"
						stroke-linecap="square"
					/>
				</g>
				<text
					x="50%"
					y="50.55%"
					fill="#EDEDED"
					font-size="10.5"
					width="100%"
					dominant-baseline="middle"
					text-anchor="middle">{windDirection?.direction || 'N/A'}</text
				>
			</svg>
		</div>
	</div>
</div>

<style>
	/* BODY STYLING */
	.card {
		background-color: #141719;
		opacity: 90%;
		border-radius: 12px;
		padding: 8px 10px;
		margin: 0 4px 8px;
	}
	.header-row {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-bottom: 4px;
		margin-top: 4px;
	}
	.header-icon {
		font-size: 14px;
		color: #8e8e93;
	}
	.label {
		display: flex;
		align-self: center;
		justify-content: center;
		color: #818588;
		font-size: 10px;
		font-weight: 500;
		text-transform: uppercase;
		letter-spacing: 0.8px;
	}

	.second-label {
		font-size: 12px;
		color: #ededed;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		margin-right: 2px;
	}

	/* WIND CARD*/
	.content-wind {
		display: flex;
		justify-content: space-between;
		width: 100%;
		gap: 16px;
	}
	.wind-left-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-top: 0.4rem;
	}
	.wind-item {
		display: flex;
		justify-content: space-between;
		min-width: 120px;
		padding: 5px 0;
	}
	.wind-value {
		font-size: 12px;
		color: #ededed;
	}
	.wind-separator {
		height: 1px;
		background-color: #2a2d31;
		margin: 8px 0;
		width: 100%;
	}
	.wind-right-container {
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 42%;
	}
	.second-value {
		font-size: 12px;
		color: #ededed;
		white-space: nowrap;
		align-self: center;
	}
	svg {
		transform: scale(1.35);
		max-width: 100%;
	}
	svg g#wind-arrow {
		transform-origin: center center;
		transition: transform 1s ease-in-out;
	}

	/* MEDIA QUERIES */
	@media (max-width: 319px) {
		.wind {
			grid-column: 1;
			grid-row: 3;
			display: flex;
		}
		.content-wind {
			flex-direction: column;
			gap: 8px;
		}
		.wind-right-container {
			width: 100%;
			display: flex;
			margin: 8px 0 4px;
		}
		.wind-details {
			width: 100%; /* Full width on mobile */
		}
	}
	@media (max-width: 379px) {
		.wind-details .second-label,
		.wind-details .second-value {
			font-size: 10px;
		}
		.wind-details .wind-item {
			min-width: 100px;
		}
	}
</style>
